import { useMemo } from "react";
import { CompanyOwner } from "../../types/schema";
import { tExtendedCompanyWithCounts } from "../../types";
import { isDateInFuture, willExpireWithinAWeek, formatDate } from "../../utils/helperFunctions";

interface StatsCardsRowProps {
    companyOwnerData: CompanyOwner[];
    companyDataByOwner: tExtendedCompanyWithCounts[];
}

export const StatsCardsRow = ({ companyOwnerData, companyDataByOwner }: StatsCardsRowProps) => {
    const stats = useMemo(() => {
        const totalCompanies = companyDataByOwner.length;

        const totalUsers = companyDataByOwner.reduce(
            (sum, c) => sum + (c.userCount || 0), 0
        );

        const today = formatDate(new Date());
        const expiringOrExpired = companyDataByOwner.filter(c => {
            const exp = c.subscriptionExpiration;
            if (!exp) return false;
            return !isDateInFuture(exp) || willExpireWithinAWeek(exp, today);
        }).length;

        const activeSubscriptions = companyDataByOwner.filter(c =>
            isDateInFuture(c.subscriptionExpiration)
        ).length;

        const freeDemo = companyOwnerData.filter(
            o => o.subscriptionType === "free-demo"
        ).length;

        return { totalCompanies, totalUsers, expiringOrExpired, activeSubscriptions, freeDemo };
    }, [companyOwnerData, companyDataByOwner]);

    return (
        <div className="sam-stats-row">
            <div className="sam-stat-card">
                <p className="sam-stat-label">Total Companies</p>
                <p className="sam-stat-value">{stats.totalCompanies}</p>
                <p className="sam-stat-detail">
                    <span className="sam-dot-green" />
                    {stats.activeSubscriptions} active subscriptions
                </p>
            </div>
            <div className="sam-stat-card">
                <p className="sam-stat-label">Total Users</p>
                <p className="sam-stat-value">{stats.totalUsers}</p>
                <p className="sam-stat-detail">
                    <span className="sam-dot-green" />
                    Across all companies
                </p>
            </div>
            <div className="sam-stat-card">
                <p className="sam-stat-label">Expiring Soon / Expired</p>
                <p className="sam-stat-value">{stats.expiringOrExpired}</p>
                <p className="sam-stat-detail">
                    {stats.expiringOrExpired > 0 && <span className="sam-dot-orange" />}
                    {stats.expiringOrExpired === 1 ? "1 expired" : `${stats.expiringOrExpired} expired`}
                </p>
            </div>
            <div className="sam-stat-card">
                <p className="sam-stat-label">Free Demo</p>
                <p className="sam-stat-value">{stats.freeDemo}</p>
                <p className="sam-stat-detail">Conversion opportunities</p>
            </div>
        </div>
    );
};
